module.exports = "/_next/static/images/e34992b58513ef2e8c76908288dcbc43-email-verification-loading.png";